import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const getChargerServiceabilities: UseCase<ChargerRepository, 'getChargerServiceabilities'> = repository => {
  return async (chargerUid) => {
    return await repository.getChargerServiceabilities(chargerUid)
  }
}
